const idTypes = {
  SHOPPER_ID: 'shopperId',
  VISITOR_GUID: 'visitorGuid'
};

const switchboardIdTypes = {
  VISITOR_ID: 'visitorId',
  CUSTOMER_ID: 'customerId',
  SHOPPER_ID: 'shopperId'
};

const experimentSources = {
  SWITCHBOARD: 'appConfig',
  SPLIT_IO: 'split.io'
};

const DEFAULT_COHORT = 'ineligible';
const PARAMETER_LABEL = 'parameter';

module.exports = {
  idTypes,
  switchboardIdTypes,
  experimentSources,
  DEFAULT_COHORT,
  PARAMETER_LABEL
};
